import { useMemo } from 'react';

import { useAuthentication } from '@givebacks/api';
import { IfFeatureState_Core } from 'core';
import { PagesUrl } from 'core/Utils';
import { NavLink, useMatch } from 'react-router-dom';
import { ButtonMantine, Group, NavLink as MantineNavLink, Menu, ThemeIcon } from 'ui';
import { IconChevronDownTabler } from 'ui/Icons';

import classes from './DesktopNavLinks.module.css';

const NavLinkButton = ({ label, active }: { label: string; active?: boolean | null }) => {
  return (
    <Menu.Target>
      <ButtonMantine
        variant="transparent"
        rightSection={
          <ThemeIcon variant="transparent" size={'xs'} c={active ? 'cobalt.4' : 'gray.4'}>
            <IconChevronDownTabler brand="tabler" />
          </ThemeIcon>
        }
        classNames={{
          root: classes.root,
          section: classes.section,
          label: classes.label,
        }}
        mod={{ active }}
      >
        {label}
      </ButtonMantine>
    </Menu.Target>
  );
};

const HomeLink = () => {
  return (
    <MantineNavLink label="Home" className={classes.navLink} component={NavLink} to={'home'} />
  );
};

const SearchMenu = () => {
  const isGiveRoute = useMatch('give/*');
  const isCauseRoute = useMatch('causes');

  const isGiveActive = useMemo(() => !!isGiveRoute || !!isCauseRoute, [isGiveRoute, isCauseRoute]);

  return (
    <MantineNavLink
      label="Search"
      className={classes.navLink}
      component={NavLink}
      to={PagesUrl.CAUSES}
      active={isGiveActive}
    />
  );
};

const RewardsMenu = () => {
  const isRewardsRoute = useMatch('rewards/*');

  return (
    <Menu position="bottom-start" trigger="click-hover">
      <NavLinkButton label="Rewards" active={!!isRewardsRoute} />
      <Menu.Dropdown miw={140}>
        <Menu.Item component={NavLink} to={'rewards/dining'}>
          Dining
        </Menu.Item>
        <Menu.Item component={NavLink} to={'rewards/online'}>
          Online
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

const FeesLink = () => {
  return (
    <IfFeatureState_Core featureId="user.studentFees">
      <MantineNavLink
        label="Fees"
        className={classes.navLink}
        component={NavLink}
        to={'/student-fees'}
      />
    </IfFeatureState_Core>
  );
};

const AccountLink = () => {
  return (
    <MantineNavLink
      label="Account"
      className={classes.navLink}
      component={NavLink}
      to={'/account'}
    />
  );
};

const DesktopNavLinks = () => {
  const { isAuthenticated } = useAuthentication();

  return (
    <Group pt={4} justify="center" gap="md">
      <HomeLink />
      <FeesLink />
      <SearchMenu />
      <RewardsMenu />
      {isAuthenticated && <AccountLink />}
    </Group>
  );
};

export { DesktopNavLinks };
